const styles = () => ({
	container: {
		display: 'flex',
		flexFlow: 'row nowrap',

		maxHeight: 80,
		minHeight: 40,
		padding: '40px 32px 16px 16px',
		background: '#1B3E6F',
		color: 'white',
		boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
	},
	back: {
		padding: 4,
		width: 32,
		height: 32,
		minWidth: 32,
		minHeight: 32,

		border: 'none',
		background: 'rgba(0,0,0,0)'
	},
	icon: {
		margin: 0,
		width: 16,
		height: 16,
		color: 'white'
	},
	title: {
		display: 'flex',

		margin: 0,
		padding: 0,
		marginLeft: 32,
		minHeight: '24px',

		lineHeight: '24px',
		fontSize: 18,

		'@global img': {
			display: 'block'
		}
	},
	'@media (max-width: 1024px)': {
		container: {
			height: 80
		}
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/components/main/header/styles.js